module.exports = __webpack_public_path__ + "static/oasisliteracy-560eebe0a813a63d1b01b89430560bdd.jpg";